export default __webpack_public_path__ + "static/banner_RAW-35d7b711f30d3a912fe054a4ea886236.jpg";